import { useState } from 'react'
import { FiChevronDown } from 'react-icons/fi'
import SelectCoin from './SelectCoin'
import { Text, useWindowSize } from '../../Dashboard'
import { SOCKET_URL } from '../../../core/constants/urls'
import { DText } from '../../../styles/CommonStyles'
import ModalLayout from '../../../components/layouts/ModalLayout'
import MobileModal from '../../../components/layouts/MobileModal'
import { IoMdArrowDropdown } from "react-icons/io";

const CoinRow = ({ coin, ...rest }) => {
	const { width } = useWindowSize()

	return (
		<div className={'flex items-center gap-1'} {...rest}>
			{!!coin ? (
				<>
					<img
						src={SOCKET_URL + `assets/icon/${coin.id}.png`}
						width={width > 1024 ? 24 : 18}
						height={width > 1024 ? 24 : 18}
						style={{ margin: '0 4px' }}
						alt={coin.id}
					/>
					<DText main className='text-sm'>
						{/* {`${
                            lang === 'fa' ? coin.fa : coin.name
                        } (${coin?.id?.toUpperCase()})`} */}
						{(coin?.id?.toUpperCase() ?? coin.fa)}
					</DText>
				</>
			) : <Text tid="select-coin" className='uppercase' />}
		</div>
	)
}

const CryptoCoinSelect = ({ coin, type, onChange, size = 30, between, className }) => {
	const [coinModal, setCoinModal] = useState(false)
	const openCoinModal = () => setCoinModal(true)
	const closeCoinModal = () => setCoinModal(false)

	const { width } = useWindowSize()

	return (
		<>
			<div
				className={`flex justify-between gap-2 px-3 items-center w-full h-full cursor-pointer ${className}`}
				onClick={openCoinModal}
			>
				<CoinRow coin={coin} size={size} />
				<IoMdArrowDropdown size={22} className='rounded' />
			</div>
			{width >= 1024 ? (
				<ModalLayout title={"select-coin"} open={coinModal} onClose={closeCoinModal} width={'520px'} isPortal>
					<SelectCoin onClose={closeCoinModal} type={type} onChange={onChange} />
				</ModalLayout>
			) : (
				<MobileModal title={"select-coin"} isOpen={coinModal} onClose={closeCoinModal}>
					<SelectCoin onClose={closeCoinModal} type={type} onChange={onChange} />
				</MobileModal>
			)}
		</>
	)
}

export default CryptoCoinSelect
